export const mapSizes = {
  md: {
    height: 1024,
    width: 1024
  },
  lg: {
    width: 1280,
    height: 1280
  }
};

export const transitionOptions = {
  from: {
    opacity: 0,
    left: 50
  },
  to: [
    {
      opacity: 1,
      left: 0,
      delay: 3500,
      config: {
        duration: 200
      },
    },
    {
      opacity: 0,
      left: 50,
      delay: 3500,
      config: {
        duration: 200
      },
    }
  ],
  loop: {
    reverse: true,
    delay: 300
  }
}

export const mapOptions = {
  map: {
    from: {
      top: -404,
      left: -675,
      transform: "rotate(48deg)"
    },
    to: [
      {
        top: -404,
        left: -600,
        transform: "rotate(-12deg)",
        delay: 3500,
        config: {
          duration: 3900
        }
      }
    ],
    loop: {
      from: {
        top: -404,
        left: -675,
        transform: "rotate(48deg)"
      },
      delay: 300,
    },
  },
  car: {
    lightingColor: "#47B4E3",
    label: "2022 Tesla",
    color: "#47B4E3",
    wrapper: {
      from: {
        top: 480,
        left: 600,
        transform: "rotate(-48deg)"
      },
      to: [
        {
          top: 496,
          left: 621,
          transform: "rotate(-38deg)",
          delay: 3500,
          config: {
            duration: 650
          },
        },
        {
          top: 513,
          left: 637,
          transform: "rotate(-28deg)",
          config: {
            duration: 650
          },
        },
        {
          top: 534,
          left: 648,
          transform: "rotate(-18deg)",
          config: {
            duration: 650
          },
        },
        {
          top: 555,
          left: 655,
          transform: "rotate(-8deg)",
          config: {
            duration: 650
          },
        },
        {
          top: 579,
          left: 660,
          transform: "rotate(2deg)",
          config: {
            duration: 650
          }
        },
        {
          top: 603,
          left: 662,
          transform: "rotate(12deg)",
          config: {
            duration: 650
          }
        }
      ],
      loop: {
        from: {
          top: 480,
          left: 600,
          transform: "rotate(-48deg)"
        },
        delay: 300
      },
    },
    icon: {
      from: {
        transform: "rotate(180deg)"
      }
    }
  }
}